import { Sparkles } from "lucide-react";
import { useUserInterests } from "@/hooks/useInterests";

interface InterestsButtonProps {
  onClick: () => void;
}

const InterestsButton = ({ onClick }: InterestsButtonProps) => {
  const { userInterestIds } = useUserInterests();
  const count = userInterestIds.size;

  return (
    <button
      onClick={onClick}
      className="flex items-center gap-2 px-4 py-3 rounded-xl bg-card border border-border hover:border-primary/30 transition-all"
    >
      <div className="p-2 rounded-full bg-primary/10">
        <Sparkles className="w-5 h-5 text-primary" />
      </div>
      <div className="text-left">
        <p className="font-medium text-sm">Your Interests</p>
        <p className="text-xs text-muted-foreground">
          {count === 0
            ? "Add interests for better matches"
            : `${count} interest${count !== 1 ? "s" : ""} selected`}
        </p>
      </div>
    </button>
  );
};

export default InterestsButton;
